import { makeStyles } from "tss-react/mui";

export const useLotBidAndInfoStyles = makeStyles()((theme) => ({
    containerWidth: {
        maxWidth: '1280px'
    }
}));
